import 'moment/locale/nl.js'
import moment from 'moment'
import { i18n } from 'i18next'

export const host = typeof window !== 'undefined' ? window.location.hostname : null

export const isServer: boolean = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export function capitalise(string = '') {
  return string && string[0].toUpperCase() + string.slice(1)
}

export function centsToEuros(cents: number) {
  const amount = cents / 100

  return Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount)
}

export function toEuros(amount: number) {
  return Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount)
}

export function toFloat(input: number | string): number {
  return parseFloat(`${input}`.replace(',', '.'))
}

export function join(delimiter = ' ', ...args: string[]) {
  return args.join(delimiter).trim()
}

export function sluggify(string: string = '') {
  return (
    string &&
    [...string.toLowerCase()]
      .filter((char) => /[a-zA-Z\s-]/.test(char))
      .join('')
      .replace(/\s/g, '-')
  )
}

export function toQueryString(params: { [key: string]: string | number | boolean }) {
  return Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
}

export function validateEmailAddress(email: string = ''): boolean {
  const regex =
    /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~]{1,64}@(?:[a-zA-Z0-9-]{1,63}[.]{1}){1,125}[a-zA-Z0-9]{2,63}$/

  return email.length > 0 && regex.test(email)
}

export function eurosToCents(value: string): number {
  return parseInt(`${parseFloat(value) * 100}`, 10)
}

export function minimumPrice({
  minGroupSize = 1,
  pricePerPersonInCents = 0,
}: {
  minGroupSize: number
  pricePerPersonInCents: number | string
}) {
  if ('string' === typeof pricePerPersonInCents) {
    const asNumber = parseFloat(pricePerPersonInCents?.replace(',', '.'))

    return minGroupSize * asNumber
  }

  if ('number' === typeof pricePerPersonInCents) {
    return minGroupSize * pricePerPersonInCents
  }

  return 0
}

export function toLocalDate(i18n: i18n, date: moment.MomentInput) {
  moment.locale(i18n.language)

  return moment.utc(date).local().format('DD.MM.YYYY., HH:mm:ss')
}
